/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as BusinessRouteImport } from './routes/business'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PIndexRouteImport } from './routes/p.index'
import { Route as PPointIdRouteImport } from './routes/p.$pointId'

const BusinessRoute = BusinessRouteImport.update({
  id: '/business',
  path: '/business',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PIndexRoute = PIndexRouteImport.update({
  id: '/p/',
  path: '/p/',
  getParentRoute: () => rootRouteImport,
} as any)
const PPointIdRoute = PPointIdRouteImport.update({
  id: '/p/$pointId',
  path: '/p/$pointId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/business': typeof BusinessRoute
  '/p/$pointId': typeof PPointIdRoute
  '/p/': typeof PIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/business': typeof BusinessRoute
  '/p/$pointId': typeof PPointIdRoute
  '/p': typeof PIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/business': typeof BusinessRoute
  '/p/$pointId': typeof PPointIdRoute
  '/p/': typeof PIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/business' | '/p/$pointId' | '/p/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/business' | '/p/$pointId' | '/p'
  id: '__root__' | '/' | '/business' | '/p/$pointId' | '/p/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BusinessRoute: typeof BusinessRoute
  PPointIdRoute: typeof PPointIdRoute
  PIndexRoute: typeof PIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/business': {
      id: '/business'
      path: '/business'
      fullPath: '/business'
      preLoaderRoute: typeof BusinessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/': {
      id: '/p/'
      path: '/p'
      fullPath: '/p/'
      preLoaderRoute: typeof PIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$pointId': {
      id: '/p/$pointId'
      path: '/p/$pointId'
      fullPath: '/p/$pointId'
      preLoaderRoute: typeof PPointIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BusinessRoute: BusinessRoute,
  PPointIdRoute: PPointIdRoute,
  PIndexRoute: PIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
